<template>
    <div>
        <div class="bg-grey vh-100" id="listpotonganx">

            <!-- HEADER -->
            <div class="header-top bg-white showPageDefault">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left">
                        <div class="header-item" @click="backtolistpenggajian">
                            <img src="../../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">Rekap Denda</div>
                    <div class="header-top--right" v-on:click="Searchpotonganx">
                        <div class="header-item">
                            <img src="../../../assets/icons/search.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="header-top bg-white showPageSearch fix-header-top">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left add-padding-default">
                        <input class="inputSearch" id="input_searchKomisix" type="text" v-on:keyup="searchPotonganx" v-model="searchKeypotonganx"
                               placeholder="Cari..">
                    </div>
                    <div class="header-top--right" v-on:click="closeSearchPotongan">
                        <div class="header-item">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="showPageSearch">
                <!-- CONTENT -->
                <div class="content-wrapper main-page" v-if="listpotonganxPsearch.length >= 0">
                    <div class="Search-BOX mar-top-16 add-padding-default mar-bottom-16" id="textToppotonganx"></div>
                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit">
                        <!-- LIST ITEMS -->
                        <div class="card-item-wrapper mar-bot-12" v-for="listpotonganxS in listpotonganxPsearch" :key="listpotonganxS.id">
                            <div class="card-item" :id="'dropdownMenuLinklistpotongan'+listpotonganxS.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	                            <div class="top-card">
		                            <div class="f-16 f-semi">
										Rp.{{ listpotonganxS.nominal }}
										<span v-if="listpotonganxS.statuspelunasan ===2" class="f-12 f-c-midgrey">
											(sisa bayar {{ listpotonganxS.saldo }})
										</span>
									</div>
		                            <div class="card-menu-vertical"></div>
	                            </div>
	                            <div class="f-14 f-c-midgrey m-t-4"
	                                 v-html="searchHighlight(listpotonganxS.keterangan, searchKeypotonganx)"></div>
	                            <div class="separator-line m-x-min m-t-10"></div>
	                            <div class="bottom-card m-t-10" v-if="listpotonganxS.statuspelunasan ===0">
		                            <div class="f-12 f-c-midgrey">{{ listpotonganxS.waktu }}</div>
		                            <div class="badge color-red">Belum Lunas</div>
	                            </div>
	                            <div class="bottom-card m-t-10" v-else-if="listpotonganxS.statuspelunasan ===1">
		                            <div class="f-12 f-c-midgrey">{{ listpotonganxS.waktu }}</div>
		                            <div class="badge color-green">Lunas {{ (listpotonganxS.tanggal_lunas === '-') ? '' : listpotonganxS.tanggal_lunas }}</div>
	                            </div>
                                <div class="bottom-card m-t-10" v-else-if="listpotonganxS.statuspelunasan ===2">
									<div class="f-12 f-c-midgrey">{{ listpotonganxS.waktu }}</div>
                                    <div class="badge color-yellow">Cicilan</div>
                                </div>

                                <div class="dropdown-menu garis-listkomisi" v-if="listpotonganxS.statuspelunasan ===1 && validateAccess('fine.read')" @click="detailpotongansx(listpotonganxS.id)">
                                    <div class="dropdown-item" href="#"><span
                                            class="mar-right-10"><img src="../../../assets/icons/file-text_2.svg"></span>Detail Denda</div>
                                </div>
                                <div class="dropdown-menu garis-listkomisi" v-if="listpotonganxS.statuspelunasan ===2 || listpotonganxS.statuspelunasan ===0">
                                    <div class="dropdown-item" href="#" v-if="validateAccess('fine.pay')" @click="bayarpotonganx(listpotonganxS.id)"><span
                                            class="mar-right-10"><img src="../../../assets/icons/mdi_cash-plus.svg"></span>Bayar Denda</div>
                                    <div class="dropdown-item f-c-red" href="#" v-if="listpotonganxS.statuspelunasan ===0 && validateAccess('fine.delete')" @click="showHapusDenda(listpotonganxS)"><span
                                        class="mar-right-10"><img src="../../../assets/icons/trash-red.svg"></span>Hapus</div>
                                </div>

                            </div>
                        </div>
	                    <div class="loadmoreSpinner" id="loadingSpinnerListPotonganSearch" style="display: none">
		                    <center>
			                    <div class="sp sp-circle"></div>
		                    </center>
	                    </div>

                    </div>
                </div>
            </div>

            <div class="showPageDefault">

                <!-- CONTENT -->
                <div class="content-wrapper main-page">
                    <div class="bg-white">
                        <div class="p-x-20 p-y-16 w-limit">
                            <div class="f-16 f-bold">{{ detailDenda.nama_karyawan }}</div>
                            <div class="f-14 f-c-midgrey">
                                <span v-if="detailDenda.bekerja_kasir === 1">Kasir {{ detailDenda.outlet }}<span class="m-l-4 m-r-4">•</span></span>
                                <span v-if="detailDenda.bekerja_produksi === 1">Workshop {{ detailDenda.workshop }}<span class="m-l-4 m-r-4">•</span></span>
                                <span v-if="detailDenda.bekerja_kurir === 1">Kurir</span>
                            </div>
                            <div class="f-14 color-6f7">Total denda {{ detailDenda.total_denda | currency }}</div>
                        </div>
                    </div>

                    <!-- IF EMPTY -->
                    <div class="empty-state display-none">
                        <div class="empty-state--icon"></div>
                        <div class="f-16 f-bold">Belum ada denda karyawan</div>
                        <div class="f-14 f-c-midgrey">Denda yang terdaftar akan tampil disini</div>
                    </div>

                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit">

                        <div class="d-flex justify-content-between m-d-16">
                            <div class="f-16 f-c-midgrey">{{this.leght_data_potonganx}} Denda</div>
	                        
	                        <FilterSorting @filter="filter" :jenisFilter="'listPotongan'" style="margin-top: -6px"/>
                        </div>

                        <!-- LIST ITEMS -->
                        <div class="card-item-wrapper mar-bot-12" v-for="potonganx in listpotonganx" :key="potonganx.id">
                            <div class="card-item" style="position: relative" :id="'dropdownMenuLinklistpotongan'+potonganx.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="top-card">
                                    <div class="f-16 f-semi">
										Rp.{{ potonganx.nominal }}
										<span v-if="potonganx.statuspelunasan ===2" class="f-12 f-c-midgrey">
											(sisa bayar {{ potonganx.saldo }})
										</span>
									</div>
                                    <div class="card-menu-vertical"></div>
                                </div>
                                <div class="f-14 f-c-midgrey m-t-4">{{potonganx.keterangan}}</div>
                                <div class="separator-line m-x-min m-t-10"></div>
                                <div class="bottom-card m-t-10" v-if="potonganx.statuspelunasan ===0">
                                    <div class="f-12 f-c-midgrey">{{ potonganx.waktu }}</div>
                                    <div class="badge color-red">Belum Lunas</div>
                                </div>
                                <div class="bottom-card m-t-10" v-else-if="potonganx.statuspelunasan ===1">
                                    <div class="f-12 f-c-midgrey">{{ potonganx.waktu }}</div>
                                    <div class="badge color-green">Lunas {{ (potonganx.tanggal_lunas === '-') ? '' : potonganx.tanggal_lunas }}</div>
                                </div>
                                <div class="bottom-card m-t-10" v-else-if="potonganx.statuspelunasan ===2">
                                    <div class="f-12 f-c-midgrey">{{ potonganx.waktu }}</div>
                                    <div class="badge color-yellow">Cicilan</div>
                                </div>
                                <div class="dropdown-menu garis-listkomisi" v-if="potonganx.statuspelunasan ===1 && validateAccess('fine.read')" @click="detailpotongansx(potonganx.id)">
                                    <div class="dropdown-item" href="#"><span
                                            class="mar-right-10"><img src="../../../assets/icons/file-text_2.svg"></span>Detail Denda</div>
                                </div>
                                <div class="dropdown-menu garis-listkomisi" v-if="potonganx.statuspelunasan ===2 || potonganx.statuspelunasan ===0">
                                    <div class="dropdown-item" href="#" v-if="validateAccess('fine.pay')" @click="bayarpotonganx(potonganx.id)"><span
                                            class="mar-right-10"><img src="../../../assets/icons/mdi_cash-plus.svg"></span>Bayar Denda</div>
                                    <div class="dropdown-item f-c-red" href="#" v-if="potonganx.statuspelunasan ===0 && validateAccess('fine.pay')" @click="showHapusDenda(potonganx)"><span
                                            class="mar-right-10"><img src="../../../assets/icons/trash-red.svg"></span>Hapus</div>
                                </div>
                            </div>
                        </div>
	                    <div class="loadmoreSpinner" id="loadingSpinnerListPotongan" style="display: none">
		                    <center>
			                    <div class="sp sp-circle"></div>
		                    </center>
	                    </div>
                    </div>

                    <!-- CONTEXT MENU -->

                </div>

            </div>

        </div>

		<div class="modal fade" id="modalHapusDenda" role="dialog">
			<div class="modal-dialog modal-lg  bani-modal">
				<div class="modal-content">
					<div class="modal-header">
						<div class="nav-btn kiri"></div>
						<h5 class="navbar-title text-center">Konfirmasi Hapus Denda</h5>
						<div class="nav-btn kanan tutup">
							<img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
						</div>
					</div>
					<div class="modal-body">
						<p class="f-c-black f-16 m-0">
							Anda yakin ingin menghapus denda <b>{{ selectedKasbon.nama }}</b>?
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-primary btn-long"
								@click="hapusDenda(selectedKasbon)" :disabled="isClicked">
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
								  v-if="isClicked"></span>
							<span v-else>Ya, Hapus</span>
						</button>
					</div>
				</div>
			</div>
		</div>

    </div>

</template>

<script>
	import FilterSorting from "@/component-items/FilterSorting";

    export default {
        name: "listpotongan",
	    components: {FilterSorting},
        data() {
            return {
	            idkaryawan: "",

            	detailDenda: {},
                listpotonganx:[],
                leght_data_potonganx:'',
                searchKeypotonganx:'',
                potonganxSearch:[],
                nominal_lunas_list:'',
                nominal_cicil_list:'',
                listpotonganxPsearch:[],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	
	            listPotonganPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "created_at",
		            orderBy: "DESC",
	            },
	            listPotonganSearchPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "created_at",
		            orderBy: "DESC",
		            key: "",
	            },

				selectedKasbon: {},
				isClicked: false,
            }
        },
        mounted(){
            // this.listpotongansx();
            $(".showPageSearch").prop("style", "display:none");
            this.scroll()

			this.backButtonPressed(this.backtolistpenggajian)
        },
        methods:{
	        scroll() {
		        window.onscroll = () => {
			        if ($('#loadingSpinnerListPotongan').is(":hidden")) {
				        if ($(".showPageDefault").is(":visible")) {
					        if (this.listPotonganPagination.pageNumber <= Math.ceil(this.listPotonganPagination.length / this.listPotonganPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.listPotonganPagination.offset = (this.listPotonganPagination.pageNumber * this.listPotonganPagination.limit);
							        if (this.listPotonganPagination.offset > 0) {
								        this.listpotongansx(this.idkaryawan);
							        }
							        $('#loadingSpinnerListPotongan').show()
						        }
					        }
				        }
			        }
			
			        if ($('#loadingSpinnerListPotonganSearch').is(":hidden")) {
				        if ($(".showPageSearch").is(":visible")) {
					        if (this.listPotonganSearchPagination.pageNumber <= Math.ceil(this.listPotonganSearchPagination.length / this.listPotonganSearchPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.listPotonganSearchPagination.offset = (this.listPotonganSearchPagination.pageNumber * this.listPotonganSearchPagination.limit);
							        this.searchPotonganx();
							        $('#loadingSpinnerListPotonganSearch').show()
						        }
					        }
				        }
			        }
		        }
	        },
            bayarpotonganx(id){
                this.$emit('bayarpotongan',id)
            },

            backtolistpenggajian(){
                this.$emit('backtolistdenda')
            },
            createpotonganx(){
                this.$emit('createpotomgan')
            },

            detailpotongansx(id){
                this.$emit('detailpotonganx',id)
            },

            // <-- Fungsi Formatrupiah nominal -->

            inputnominallistlunas(){
                var handlecicil = this.nominal_lunas_list;
                var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
                this.nominal_lunas_list=hasilcicil;
                this.formatrupiahnominallistlunas();
            },

            formatrupiahnominallistlunas(){
                var rupiahcicil = this.nominal_lunas_list;
                var formattedrupiahcicil = this.newrupiahnominallistlunas(rupiahcicil);
                this.nominal_lunas_list=formattedrupiahcicil;
            },

            newrupiahnominallistlunas(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Formatrupiah Saldo -->

            inputnominallistcicil(){
                var handlecicil = this.nominal_cicil_list;
                var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
                this.nominal_cicil_list=hasilcicil;
                this.formatrupiahnominallistcicil();
            },

            formatrupiahnominallistcicil(){
                var rupiahcicil = this.nominal_cicil_list;
                var formattedrupiahcicil = this.newrupiahnominallistcicil(rupiahcicil);
                this.nominal_cicil_list=formattedrupiahcicil;
            },

            newrupiahnominallistcicil(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Get list potongan -->

            async listpotongansx(idkaryawan){
	        	this.idkaryawan = idkaryawan
	        	if (this.listPotonganPagination.offset === 0) {
			        $('#loadingPage').addClass('overlayLoading');
			        $('#loadingPage').show()
			        this.listpotonganx = [];
		        }
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_potongan_rekap_perkaryawan'
	                    + '?idkaryawan=' + idkaryawan
	                    + '&sort_by=' + this.listPotonganPagination.sortBy
	                    + '&order_by='+ this.listPotonganPagination.orderBy
	                    + '&limit=' + this.listPotonganPagination.limit
	                    + '&offset=' + this.listPotonganPagination.offset, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();

	                    this.detailDenda = response.data.data.detail_denda

                        var data = response.data.data.rekap_denda.RekapPotongan;
                        this.listPotonganPagination.length = response.data.lenght_data
                        this.leght_data_potonganx=response.data.lenght_data;
                        if (data.length > 0) {
	                        for (var i = 0; i < data.length; i++) {
		                        var status;
		                        if (data[i].StatusPelunasan === 1){
			                        status = 1
		                        }else if(data[i].StatusPelunasan ===2){
			                        status = 2
		                        }else if(data[i].StatusPelunasan===0){
			                        status = 0
		                        }
		                        var nominal_lunas_list = data[i].Nominal;
		                        this.nominal_lunas_list = nominal_lunas_list;
		                        var toRplunas = this.newrupiahnominallistlunas(this.nominal_lunas_list.toString());
		                        var nominal_cicil_list = data[i].Saldo;
		                        this.nominal_cicil_list = nominal_cicil_list;
		                        var toRpcicil = this.newrupiahnominallistcicil(this.nominal_cicil_list.toString());
		                        this.listpotonganx.push({
			                        nama:data[i].NamaKaryawan,
			                        id:data[i].IdPotongan,
			                        keterangan:data[i].Keterangan,
			                        saldo:toRpcicil,
			                        nominal:toRplunas,
			                        waktu:data[i].WaktuPotongan,
			                        tanggal_lunas:data[i].WaktuPembayaranTerakhir,
			                        statuspelunasan : status,
									idkaryawan: data[i].Idkaryawan
		                        })
	                        }
                        }
	                    this.listPotonganPagination.pageNumber++
	                    $('#loadingSpinnerListPotongan').hide()
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false
	                $('#textBtn2').show()
	                $('#btnNext').prop('disabled', false);
                }
            },

            // Fungsi Sorting
            async sortingpotonganx(key) {
                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownfilterpotonganx').text("Urut Dari A - Z ");
                        $('#az').addClass('active')
                        $('#za').removeClass('active')
                        $('#baru').removeClass('active')
                        $('#lama').removeClass('active')
                        this.getsortingPotonganx(1);
                        break;
                    case "desc":
                        $('#dropdownfilterpotonganx').text("Urut Dari Z - A ");
                        $('#za').addClass('active');
                        $('#baru').removeClass('active');
                        $('#az').removeClass('active');
                        $('#lama').removeClass('active');
                        this.getsortingPotonganx(2)
                        break;
                    case "terbaru":
                        $('#dropdownfilterpotonganx').text("Urut Dari Terbaru ")
                        $('#baru').addClass('active');
                        $('#az').removeClass('active');
                        $('#za').removeClass('active');
                        $('#lama').removeClass('active');
                        this.getsortingPotonganx(3)
                        break;
                    case "terlama":
                        $('#dropdownfilterpotonganx').text("Urut Dari Terlama ")
                        $('#lama').addClass('active');
                        $('#baru').removeClass('active');
                        $('#az').removeClass('active');
                        $('#za').removeClass('active');
                        this.getsortingPotonganx(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            },
            async getsortingPotonganx(potonganx) {
                var sort_by;
                var order_by;
                var key;
                var limit =20;
                var offset= 0;
                key = '';
                //var key = jika ada search nanti dipake
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    if (potonganx === 1) {
                        sort_by = "karyawan.nama";
                        order_by = "ASC";
                    } else if (potonganx === 2) {
                        sort_by = "karyawan.nama";
                        order_by = "DESC";
                    } else if (potonganx === 3) {
                        sort_by = "created_at";
                        order_by = "DESC";
                    } else if (potonganx === 4) {
                        sort_by = "created_at";
                        order_by = "ASC";
                    } else {
                        return
                    }
                    // var idowner = localStorage.getItem('idowner');
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_potongan?key='+ key + '&sort_by=' + sort_by + '&order_by='+ order_by + '&limit=' + limit + '&offset=' + offset, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            this.listpotonganx = [];
                            var data = response.data.data.RekapPotongan;
                            this.leght_data_potonganx=response.data.lenght_data;
                            for (var i = 0; i < data.length; i++) {
                                var status;
                                if (data[i].StatusPelunasan === 1){
                                    status = 1
                                }else if(data[i].StatusPelunasan ===2){
                                    status = 2
                                }else if(data[i].StatusPelunasan===0){
                                    status = 0
                                }
                                var nominal_lunas_list = data[i].Nominal;
                                this.nominal_lunas_list = nominal_lunas_list;
                                var toRplunas = this.newrupiahnominallistlunas(this.nominal_lunas_list.toString());
                                var nominal_cicil_list = data[i].Saldo;
                                this.nominal_cicil_list = nominal_cicil_list;
                                var toRpcicil = this.newrupiahnominallistcicil(this.nominal_cicil_list.toString());
                                this.listpotonganx.push({
                                    nama:data[i].NamaKaryawan,
                                    id:data[i].id,
                                    keterangan:data[i].Keterangan,
                                    saldo:toRpcicil,
                                    nominal:toRplunas,
                                    waktu:data[i].WaktuPotongan,
                                    statuspelunasan : status,
                                })
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            //Fungsi Search

            closeSearchPotongan(){
                this.listpotongansx(this.idkaryawan);
                $(".showPageSearch").hide();
                $(".showPageSearch").removeClass('animated slideInDown');
                $(".showPageDefault").show();
                this.listpotonganxPsearch = [];
                this.searchKeypotonganx = "";
                
                $("#textToppotonganx").text("Minimal 2 karakter")
	            this.listPotonganSearchPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "created_at",
		            orderBy: "DESC",
		            key: "",
	            }
            },

            Searchpotonganx(){
                $(".showPageSearch").show()
                $(".showPageSearch").addClass('animated slideInDown')
                $("#textToppotonganx").text("Minimal 2 karakter")
                $(".showPageDefault").hide();
                $("#input_searchKomisix").focus();
            },

            searchPotonganx() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    // $(".spinner").prop("style", "display:inline-block");
                    this.searchPotonganxFunc();
                }, 500);
            },

            async searchPotonganxFunc() {
                var key = this.searchKeypotonganx;
                if (this.listPotonganSearchPagination.offset === 0 || this.listPotonganSearchPagination.key !== key) {
	                this.listpotonganxPsearch=[];
	                $('#loadingPage').show();
	                $('#loadingPage').addClass('overlayLoading');
	                $("#textToppotonganx").text("Sedang mencari...")
	                this.listPotonganSearchPagination = {
		                limit: 20,
		                offset:0,
		                length: 0,
		                pageNumber: 0,
		                sortBy: "created_at",
		                orderBy: "DESC",
		                key: key,
	                }
                }
                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_potongan_rekap_perkaryawan'
	                        + '?idkaryawan=' + this.idkaryawan
	                        + '&key=' + key
	                        + '&limit=' + this.listPotonganSearchPagination.limit
	                        + '&offset=' + this.listPotonganSearchPagination.offset, this.requestHeaders);
                        // if (response.status === 200) {
                            if (response.data.status === true) {

                                var data = response.data.data.rekap_denda.RekapPotongan;
                                this.listPotonganSearchPagination.length += data.length
                                this.leght_data_potonganx=response.data.lenght_data;
                                if (data.length > 0) {
	                                for (var i = 0; i < data.length; i++) {
		                                // var status = data[i].StatusPelunasan ;
		                                var status
		                                if (data[i].StatusPelunasan === 1){
			                                status = 1
		                                }else if(data[i].StatusPelunasan ===2){
			                                status = 2
		                                }else if(data[i].StatusPelunasan===0){
			                                status = 0
		                                }
		                                var nominal_lunas_list = data[i].Nominal;
		                                this.nominal_lunas_list = nominal_lunas_list;
		                                var toRplunas = this.newrupiahnominallistlunas(this.nominal_lunas_list.toString());
		                                var nominal_cicil_list = data[i].Saldo;
		                                this.nominal_cicil_list = nominal_cicil_list;
		                                var toRpcicil = this.newrupiahnominallistcicil(this.nominal_cicil_list.toString());
		                                this.listpotonganxPsearch.push({
			                                nama:data[i].NamaKaryawan,
			                                id:data[i].IdPotongan,
			                                keterangan:data[i].Keterangan,
			                                saldo:toRpcicil,
			                                nominal:toRplunas,
			                                waktu:data[i].WaktuPotongan,
			                                statuspelunasan : status,
											idkaryawan: data[i].Idkaryawan
		                                })
	                                }
	                                $('#loadingPage').hide();
	                                $('#loadingPage').removeClass('overlayLoading');
	                                if(this.leght_data_potonganx > 0){
		                                $("#textToppotonganx").text("Ditemukan "+this.leght_data_potonganx+" data potongan dengan kata '"+key+"'");
		
	                                }else{
		                                $("#textToppotonganx").text("Tidak menemukan '"+key+"'");
	                                }
                                } else {
	                                $('#loadingPage').hide();
	                                $('#loadingPage').removeClass('overlayLoading');
	                                $("#textToppotonganx").text("Tidak menemukan '"+key+"'");
                                }
	                            this.listPotonganSearchPagination.pageNumber++
	                            $('#loadingSpinnerListPotonganSearch').hide()
                            }
                        // }
                    } catch (e) {
                    	this.$catch_error_response(e)
	                    $('#loadingPage').hide();
	                    $('#loadingPage').removeClass('overlayLoading');
                    }
                } else {
                    this.listpotonganxPsearch = "";
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                    $("#textToppotonganx").text("Minimal 2 karakter")
                }
            },
			showHapusDenda(denda) {
				$("#modalHapusDenda").modal("show")
				this.selectedKasbon = denda
			},
			async hapusDenda(denda) {
				this.isClicked = true;
				try {
					let deleteDenda = new FormData()
					deleteDenda.append("iddenda", denda.id)
					deleteDenda.append("idkaryawan", denda.idkaryawan)
					const res = await this.$axios.post(this.$baseurl + "masterData/penggajian/hapus_denda_karyawan", deleteDenda, this.requestHeaders)

					if (res.data.status) {
						this.isClicked = false;
						$("#modalHapusDenda").modal("hide")
						this.$toast.success(res.data.msg)

						this.listPotonganPagination = {
							limit: 20,
							offset:0,
							length: 0,
							pageNumber: 0,
							sortBy: "created_at",
							orderBy: "DESC",
						}

						await this.listpotongansx(this.idkaryawan)
					} else {
						this.isClicked = false;
						this.$toast.error(res.data.msg)
					}
				} catch (e) {
					this.isClicked = false;
					this.$catch_error_response(e)
				}
			},
	        async filter(payload) {
		        this.listPotonganPagination = payload.data
		        await this.listpotongansx(this.idkaryawan);
		        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
	        }
        }
    }
</script>

<style scoped>
    .dropdown-item {
        padding: 8px 16px;
    }
</style>